import { QueryClient } from '@tanstack/react-query';

// The one query cache, in its own module so the auth store can empty it without importing App.tsx (which imports the store).
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
});

/**
 * Everything cached belonged to whoever was signed in. Nothing here is keyed by user, and answers stay fresh for
 * 30 seconds, so signing out and straight back in as somebody else served the previous person's inbox, bell and
 * dashboards from the cache — with no request made at all inside that window. Switching accounts empties it.
 */
export const forgetEverything = (): void => {
  queryClient.cancelQueries().catch(() => undefined);
  queryClient.clear();
};
